export const URL_START = '/start-interview/preference';
export const DEFAULT_LOCALE = 'en';



// WEBPACK FOOTER //
// ./src/preference/constants.js